import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './DEBT_Exit_Strategy_S.css';

const DEBT_Exit_Strategy_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Debt Note Token Exit Strategy');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/DEBT_Exit_Strategy', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_${i}_SECTION`;
	  const headerId = `#DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [DEBT_EXIT_STRATEGY, setDEBT_EXIT_STRATEGY] = React.useState(null);
  const [DEBT_EXIT_STRATEGY_S, setDEBT_EXIT_STRATEGY_S] = React.useState(null);

  var Ids = [];
  for(var Ele in DEBT_EXIT_STRATEGY_S){
	  for(var Sec in DEBT_EXIT_STRATEGY_S[Ele]){
			if(Sec == "id")
				Ids.push(DEBT_EXIT_STRATEGY_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(DEBT_EXIT_STRATEGY_S[Ele]["status"]);
			else if(Array.isArray(DEBT_EXIT_STRATEGY_S[Ele][Sec]))
				  for(var Row in DEBT_EXIT_STRATEGY_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in DEBT_EXIT_STRATEGY_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY`).then((response) => {
      setDEBT_EXIT_STRATEGY(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setDEBT_EXIT_STRATEGY_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!DEBT_EXIT_STRATEGY_S) return <div>Loading...</div>;

 const handleLastDataDEBT_EXIT_STRATEGY_S = async (data) => {
  };




  const handleAddDEBT_EXIT_STRATEGY_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY_S', JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY_S');
      setDEBT_EXIT_STRATEGY_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  

const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"]=value;
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
  }; 
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["2"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("2","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["2"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("2","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["2"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("2","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
  
      
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["3"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("3","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  


  
      
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["3"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("3","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  


  
      
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["3"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("3","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  


    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["4"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("4","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  

const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"]=value;
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
  }; 
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  

const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"]=value;
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
  }; 
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY_S));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"]=value;
	//handleAddDEBT_EXIT_STRATEGY_S(Temp_Data,App_Data['DEBT_EXIT_STRATEGY_S']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY_S(Temp_Data);
    setDEBT_EXIT_STRATEGY_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = DEBT_EXIT_STRATEGY_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Debt Note Token Exit Strategy')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`DEBT Exit Strategy ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0" type="text" className="form-control" placeholder="DEBT Exit Strategy ID"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter DEBT Exit Strategy ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1" type="text" className="form-control" placeholder="Asset ID"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2" type="text" className="form-control" placeholder="Offering ID"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Primary Exit Strategy`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"   onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3_Change} className="form-control" name="Primary Exit Strategy"  >
						  <option value="Hold for Income">Hold for Income</option>
						  <option value="Sale">Sale</option>
						  <option value="Refinance">Refinance</option>
						  <option value="Buyback">Buyback</option>
						  <option value="Development Completion and Sale">Development Completion and Sale</option>
						  <option value="Auction Resale">Auction Resale</option>
						  <option value="Token Holder Vote">Token Holder Vote</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Primary Exit Strategy
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Expected Hold Period Months`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0" type="text" className="form-control" placeholder="Expected Hold Period Months"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Expected Hold Period Months`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target Sale Price USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1" type="text" className="form-control" placeholder="Target Sale Price USD"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Target Sale Price USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target IRR`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2" type="text" className="form-control" placeholder="Target IRR"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Target IRR`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Refinance Allowed`)} <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0_Change} 
					  checked={DEBT_EXIT_STRATEGY_S?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"] === "true" || DEBT_EXIT_STRATEGY_S?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Buyback Option Allowed`)} <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1_Change} 
					  checked={DEBT_EXIT_STRATEGY_S?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"] === "true" || DEBT_EXIT_STRATEGY_S?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Token Holder Vote Required`)} <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2_Change} 
					  checked={DEBT_EXIT_STRATEGY_S?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"] === "true" || DEBT_EXIT_STRATEGY_S?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Exit Waterfall Text`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0" type="text" className="form-control" placeholder="Exit Waterfall Text"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4000ch' }}>
						 {t(`Enter Exit Waterfall Text`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0" type="text" className="form-control" placeholder="Submitted By"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1" type="text" className="form-control" placeholder="Submitted At"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2" type="text" className="form-control" placeholder="Reviewed By"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3" type="text" className="form-control" placeholder="Reviewed At"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"   onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"   onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`DEBT Exit Strategy ID`)}</th>
                        <th>{t(`Asset ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Primary Exit Strategy`)}</th>
                        <th>{t(`Expected Hold Period Months`)}</th>
                        <th>{t(`Target Sale Price USD`)}</th>
                        <th>{t(`Target IRR`)}</th>
                        <th>{t(`Refinance Allowed`)}</th>
                        <th>{t(`Buyback Option Allowed`)}</th>
                        <th>{t(`Token Holder Vote Required`)}</th>
                        <th>{t(`Exit Waterfall Text`)}</th>
                        <th>{t(`Submitted By`)}</th>
                        <th>{t(`Submitted At`)}</th>
                        <th>{t(`Reviewed By`)}</th>
                        <th>{t(`Reviewed At`)}</th>
                        <th>{t(`Approval Status`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {DEBT_EXIT_STRATEGY_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"]} </td>
						<td>{e["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default DEBT_Exit_Strategy_S;  